export default __webpack_public_path__ + "static/media/Carousel4.06838353.png";